// Minimal helpers to use SWID/S2 first, token_expires_at as fallback

import { isEspnTokenExpiring } from "./espnTokenValidation";
//udp is userDataPlatform

export const hasEspnCookies = (udp: any): boolean => {
  const hasCookies = !!(udp && udp.integration_name === "espn" && udp.swid && udp.s2);
  if (udp?.integration_name === "espn") {
    console.log("udp in hasEspnCookies espnSession.ts", udp);
    console.log("🔍 [ESPN Session] hasEspnCookies check:", {
      hasCookies,
      hasSwid: !!udp.swid,
      hasS2: !!udp.s2,
    });
  }
  return hasCookies;
};



// Open form if:
// - Primary: No SWID/S2 present, then use fallback
// - Fallback: isEspnTokenExpiring (23:55 time-based check) when cookies are missing
export const shouldOpenEspnReauth = (udp: any): boolean => {
  if (!udp || udp.integration_name !== "espn") {
    console.log("🔍 [ESPN Session] shouldOpenEspnReauth: Not ESPN platform or missing userDataPlatform");
    return true;
  }

  // Primary: check if SWID/S2 cookies are present
  const hasCookies = hasEspnCookies(udp);

  // If cookies are present, session is valid (no need to open form)
  if (hasCookies) {
    console.log("✅ [ESPN Session] Primary path: SWID/S2 cookies present. Session valid, no re-auth needed.");
    return false;
  }

  // Fallback: if cookies are missing, use the 23:55 time-based check
  console.log("⚠️ [ESPN Session] Primary path failed (no SWID/S2). Using fallback: checking token_expires_at (23:55 guard)...");
  const fallbackResult = isEspnTokenExpiring(udp);
  console.log("🔍 [ESPN Session] Fallback result (isEspnTokenExpiring):", {
    shouldOpenReauth: fallbackResult,
    tokenExpiresAt: udp.token_expires_at ? new Date(udp.token_expires_at).toLocaleString() : "missing",
    currentTime: new Date().toLocaleString(),
  });
  return fallbackResult;
};

